import React from 'react'
import styles from './styles.module.css'
import Link from '../Link'

const HomePageDevelopmentToolsItem = ({ title, subtitle, route, textLink }) => {
  return (
    <div className={styles.developmentToolsCardItem}>
      <h3 className="_pb-2">{title}</h3>
      <span className="_pb-4">{subtitle}</span>
      <Link href={route}>{textLink}</Link>
    </div>
  )
}

export default HomePageDevelopmentToolsItem
